import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import env from "../../services/env.js";
import security from "../../services/security.js";

class Onboarding1Controller {
  constructor($http, $state, $scope, $stateParams, $location, $timeout, AuthService, $rootScope, $cookies, TrackingService) {
    this.name = "onboarding1";
    this.$http = $http;
    this.$state = $state;
    this.$cookies = $cookies;
    this.$stateParams = $stateParams;
    this.$location = $location;
    this.$scope = $scope;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.currentUser = this.$auth.getUserData();
    this.$tracking = TrackingService;
    this.$timeout = $timeout;
    this.remain_loading_count = 0;
    this.postType = undefined;
    this.user = {
      phoneMobile: null,
      companyName: null,
      firstName: null,
      lastName: null,
      username: null,
      password: null,
    };
    if (this.$location.$$search.type === "connect") {
      this.postType = "source";
      this.$rootScope.postTypeForOnoarding = "source";
    }

    var _this = this;

    _this.$timeout(function () {
      $("body").removeClass();
    });

    console.log("what is the post type ");
    console.dir(_this.postType);
    console.dir(this.$location.$$search.FirstName);
    console.dir(this.$location.$$search.type);
    console.log("this.currentUser");
    console.dir(this.currentUser);

    _this.updateCurrentUserListener = _this.$rootScope.$on("UpdateCurrentUser", function (event, params) {
      _this.updateCurrentUser(params);
    });

    _this.$scope.$on("$destroy", _this.updateCurrentUserListener);

    if (this.$location.$$search.FirstName) {
      console.log("what is this shit");
      console.dir(this.$location.$$search.Email);
      this.user.phoneMobile = this.$location.$$search.Phone;
      this.user.companyName = this.$location.$$search.CompanyName;
      this.user.firstName = this.$location.$$search.FirstName;
      this.user.lastName = this.$location.$$search.LastName;
      this.user.username = decodeURIComponent(this.$location.$$search.Email);
      this.user.email = decodeURIComponent(this.$location.$$search.Email);
      this.user.password = this.$location.$$search.Password;
      _this.$timeout(function () {
        _this.$location.search("FirstName", null);
        _this.$location.search("LastName", null);
        _this.$location.search("CompanyName", null);
        _this.$location.search("Email", null);
        _this.$location.search("Password", null);
        _this.$location.search("Phone", null);
      }, 100);
      _this.registerNewMarketingSiteUser();
      //_this.remain_loading_count--;
      _this.$timeout(function () {});
    }
  }

  signInWithNewMarketingSiteUser() {
    var _this = this;
    _this.$auth.lazySignin(_this.user).then(
      function (data) {
        if (data.statusText == "OK") {
          _this.$timeout(function () {
            _this.currentUser = data.data;
            console.log("here is what we are sending to tracking");
            console.dir(data.data);
            _this.$tracking.reportUserRegistration(data.data);
            _this.$tracking.reportUserLogin(data.data);
            _this.$tracking.reportMarketingRegistration(data.data);
            _this.$tracking.reportMarketingSignIn(data.data);
            _this.$rootScope.$emit("UpdateCurrentUser", {
              user: data.data,
            });
          }, 100);
          _this.$timeout(function () {
            //_this.remain_loading_count++;
          }, 1100);
        } else {
          alert("error: " + data.statusText);
        }
      },
      function (data) {
        _this.$timeout(function () {
          //_this.remain_loading_count++;
          jQuery("#show-application-alert").trigger("click");
          alert("there was an error :" + data);
        }, 100);
      }
    );
  }

  registerNewMarketingSiteUser() {
    var _this = this;

    console.log("what is the user");
    console.dir(_this.user);

    _this.$timeout(function () {
      var cookies = _this.$cookies.getAll();

      var hub = _this.$cookies.get("hubspotutk");

      var marketingParams = "&";

      if (cookies.hubspotutk) {
        marketingParams = marketingParams + "hubspotutk=" + cookies.hubspotutk + "&";
      }
      if (_this.$location.$$search.utm_campaign) {
        marketingParams = marketingParams + "utm_campaign=" + _this.$location.$$search.utm_campaign + "&";
      }
      if (_this.$location.$$search.utm_medium) {
        marketingParams = marketingParams + "utm_medium=" + _this.$location.$$search.utm_medium + "&";
      }
      if (_this.$location.$$search.utm_source) {
        marketingParams = marketingParams + "utm_source=" + _this.$location.$$search.utm_source + "&";
      }
      if (_this.$location.$$search.utm_term) {
        marketingParams = marketingParams + "utm_term=" + _this.$location.$$search.utm_term + "&";
      }
      if (_this.$location.$$search.utm_content) {
        marketingParams = marketingParams + "utm_content=" + _this.$location.$$search.utm_content + "&";
      }

      var marketingParamsSubgStr = marketingParams.substring(marketingParams.length - 1, marketingParams);

      _this.$auth.lazyReg(_this.user, marketingParamsSubgStr).then(
        function (data) {
          console.log("response from registering");
          console.dir(data);
          if (data.data.status == "OK") {
            _this.signInWithNewMarketingSiteUser();
          } else {
            console.log("what is the data");
            console.dir(data);
            if (data.data.message.indexOf("Duplicate entry") > -1) {
              alert("This username you attempte to sign up with already exists. Please try another after posting the job.");
            } else {
              alert("There was an error with your registration. Please continue posting.");
            }
            _this.$timeout(function () {
              _this.remain_loading_count++;
            });
          }
        },
        function (data) {
          _this.$timeout(function () {
            _this.remain_loading_count++;
            jQuery("#show-application-alert").trigger("click");
            alert("there was an error :" + data);
          }, 100);
        }
      );
    }, 3000);
  }

  updateCurrentUser(params) {
    console.log("in the controller");
    console.dir(params);
    var _this = this;
    _this.$timeout(function () {
      _this.currentUser = params.user;
    }, 1000);
  }

  logOnboardingTracking(event) {
    var _this = this;
    if (_this.currentUser) {
      if (_this.currentUser.username.indexOf("jobble.com") === -1 || _this.currentUser.username.indexOf("jobbleapp.com") === -1) {
        _this.$tracking.reportOboardingScreenOne(event);
      }
    } else {
      _this.$tracking.reportOboardingScreenOne(event);
    }
  }
}

Onboarding1Controller.$inject = ["$http", "$state", "$stateParams", "$location", "$timeout", "auth", "$rootScope", "$cookies", "tracking"];

export default Onboarding1Controller;



// WEBPACK FOOTER //
// ./client/app/components/onboarding1/onboarding1.controller.js